import React, { DOMElement, useState, useEffect } from "react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import {
  Button,
  Checkbox,
  Box,
  TextField,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormLabel,
  Typography,
  FormHelperText,
} from "@mui/material";
import TextInput from "./commons/TextInput";
import Commons from "oc-commons/Commons";
import CheckboxInput from "./commons/CheckboxInput";
import uiActions from "../uiActions";
import Parts from "./sidebar/overview/Parts";
import Dekore from "./sidebar/overview/Dekore";
import Helper from "../../model/Helper";
import SavedModal from "./SavedModal";

export default class SaveModal extends React.Component {
    constructor() {
        super();
    }

    getSidebarParent() {
        return null;
    }

    copyToClipboard() {
        const fallbackCopyTextToClipboard = (text) => {
            var textArea = document.createElement("textarea");
            textArea.value = text;
            
            // Avoid scrolling to bottom
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";
          
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
          
            try {
                var successful = document.execCommand('copy');
                var msg = successful ? 'successful' : 'unsuccessful';
                console.log('Fallback: Copying text command was ' + msg);
            } catch (err) {
                console.error('Fallback: Oops, unable to copy', err);
            }
          
            document.body.removeChild(textArea);
        }

        const copyTextToClipboard = (text) => {
            if (!navigator.clipboard) {
                fallbackCopyTextToClipboard(text);
                return;
            }
            navigator.clipboard.writeText(text).then(() => {
                console.log('Async: Copying to clipboard was successful!');
            }, function(err) {
                console.error('Async: Could not copy text: ', err);
            });
        }

        APP.save((json)=>{
            copyTextToClipboard(window.location.href);
        }, ()=>{});
    }
    
    renderBody() {
        //TODO: SETTINGS!
        // return (<button className="button primary big-button"
        // onClick={() => this.saveClicked()} href="#">{I18N("Speichern")}</button>)
        
        const admin = APP.settings.userRole == "admin";
        const adminAndInsipration = admin && APP.configuration.Inspiration;

        return (
            <div id="stammdatenDialog" className="appear">
                <div className="spacer-before">
                    {I18N("Gespeichert lang", window.location.href)}
                </div>

                <button
                    className="button primary big-button"
                    onClick={() => this.copyToClipboard()}
                    href="#"
                >
                    {I18N("URL in Zwischenablage kopieren")}
                </button>
            </div>
        );
    }

    render() {
        return (
            <aside id="scroll-sidebar" className="sidebar stammdaten">
                    <div className="sidebar-body">{this.renderBody()}</div>
                <div className={" " + (Commons.isEmpty(this.getSidebarParent()) ? "only-mobile " : "")}>
                    <button className="primary finished-button" onClick={() => APP.uiHandler.sidebar(this.getSidebarParent())} href="#">
                        {I18N("Fertig")}
                    </button>
                </div>
            </aside>
        );
    }
}
